// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { CharitableTrustDesignerData_ProposalFragment } from '../../CharitableTrustDesignerBasicInformation/graphql/CharitableTrustDesignerData.generated';
import { PreTaxReturnLimitModal_ProposalFragment } from '../../PreTaxReturnLimitModal/graphql/PreTaxReturnLimitModalQuery.generated';
import { gql } from '@apollo/client';
import { CharitableTrustDesignerData_ProposalFragmentDoc } from '../../CharitableTrustDesignerBasicInformation/graphql/CharitableTrustDesignerData.generated';
import { PreTaxReturnLimitModal_ProposalFragmentDoc } from '../../PreTaxReturnLimitModal/graphql/PreTaxReturnLimitModalQuery.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CharitableTrustDesignerAnalysisData_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, dateOfBirth?: Time | null, displayName: string };

export type CharitableTrustDesignerAnalysisData_ProposalFragment = { __typename?: 'Proposal', id: string, crtProposal?: { __typename?: 'CRTProposal', id: string, assetValue: CurrencyUSD, assetNotes?: string | null, assetCostBasis: CurrencyUSD, termKind: Types.CharitableTrustTermKind, termYears: number, payoutKind: Types.CharitableTrustPayoutKind, payoutFrequency: Types.CharitableTrustPayoutFrequency, unitrustKind?: Types.CharitableTrustUnitrustKind | null, annuityPayoutAmount?: CurrencyUSD | null, unitrustPayoutPercent?: Percent | null, rate7520?: Percent | null, optimizationTarget?: Types.CharitableTrustOptimizationTarget | null, calculationMethod?: Types.CharitableTrustCalculationMethod | null, donors: Array<(
      { __typename?: 'ClientProfile' }
      & CharitableTrustDesignerAnalysisData_ClientProfileFragment
    )> } | null, cltProposal?: { __typename?: 'CLTProposal', id: string, assetValue: CurrencyUSD, assetNotes?: string | null, assetCostBasis: CurrencyUSD, termKind: Types.CharitableTrustTermKind, termYears: number, payoutKind: Types.CharitableTrustPayoutKind, payoutFrequency: Types.CharitableTrustPayoutFrequency, unitrustKind?: Types.CharitableTrustUnitrustKind | null, annuityPayoutAmount?: CurrencyUSD | null, unitrustPayoutPercent?: Percent | null, rate7520?: Percent | null, optimizationTarget?: Types.CharitableTrustOptimizationTarget | null, calculationMethod?: Types.CharitableTrustCalculationMethod | null, donors: Array<(
      { __typename?: 'ClientProfile' }
      & CharitableTrustDesignerAnalysisData_ClientProfileFragment
    )> } | null };

export type CharitableTrustDesignerAnalysisDataQueryVariables = Types.Exact<{
  proposalId: Types.Scalars['ID']['input'];
}>;


export type CharitableTrustDesignerAnalysisDataQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: (
        { __typename?: 'Proposal', id: string }
        & CharitableTrustDesignerAnalysisData_ProposalFragment
        & CharitableTrustDesignerData_ProposalFragment
        & PreTaxReturnLimitModal_ProposalFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    CharitableTrustDesignerAnalysisData: 'CharitableTrustDesignerAnalysisData' as const
  },
  Fragment: {
    CharitableTrustDesignerAnalysisData_ClientProfile: 'CharitableTrustDesignerAnalysisData_ClientProfile' as const,
    CharitableTrustDesignerAnalysisData_Proposal: 'CharitableTrustDesignerAnalysisData_Proposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CharitableTrustDesignerAnalysisData_ClientProfileFragmentDoc = gql`
    fragment CharitableTrustDesignerAnalysisData_ClientProfile on ClientProfile {
  id
  dateOfBirth
  displayName
}
    `;
export const CharitableTrustDesignerAnalysisData_ProposalFragmentDoc = gql`
    fragment CharitableTrustDesignerAnalysisData_Proposal on Proposal {
  id
  crtProposal {
    id
    donors {
      ...CharitableTrustDesignerAnalysisData_ClientProfile
    }
    assetValue
    assetNotes
    assetCostBasis
    termKind
    termYears
    payoutKind
    payoutFrequency
    unitrustKind
    annuityPayoutAmount
    unitrustPayoutPercent
    rate7520
    optimizationTarget
    calculationMethod
  }
  cltProposal {
    id
    donors {
      ...CharitableTrustDesignerAnalysisData_ClientProfile
    }
    assetValue
    assetNotes
    assetCostBasis
    termKind
    termYears
    payoutKind
    payoutFrequency
    unitrustKind
    annuityPayoutAmount
    unitrustPayoutPercent
    rate7520
    optimizationTarget
    calculationMethod
  }
}
    ${CharitableTrustDesignerAnalysisData_ClientProfileFragmentDoc}`;
export const CharitableTrustDesignerAnalysisDataDocument = gql`
    query CharitableTrustDesignerAnalysisData($proposalId: ID!) {
  proposals(where: {id: $proposalId}) {
    edges {
      node {
        id
        ...CharitableTrustDesignerAnalysisData_Proposal
        ...CharitableTrustDesignerData_Proposal
        ...PreTaxReturnLimitModal_Proposal
      }
    }
  }
}
    ${CharitableTrustDesignerAnalysisData_ProposalFragmentDoc}
${CharitableTrustDesignerData_ProposalFragmentDoc}
${PreTaxReturnLimitModal_ProposalFragmentDoc}`;

/**
 * __useCharitableTrustDesignerAnalysisDataQuery__
 *
 * To run a query within a React component, call `useCharitableTrustDesignerAnalysisDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharitableTrustDesignerAnalysisDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharitableTrustDesignerAnalysisDataQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCharitableTrustDesignerAnalysisDataQuery(baseOptions: Apollo.QueryHookOptions<CharitableTrustDesignerAnalysisDataQuery, CharitableTrustDesignerAnalysisDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharitableTrustDesignerAnalysisDataQuery, CharitableTrustDesignerAnalysisDataQueryVariables>(CharitableTrustDesignerAnalysisDataDocument, withFetchPolicyContext(options));
      }
export function useCharitableTrustDesignerAnalysisDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharitableTrustDesignerAnalysisDataQuery, CharitableTrustDesignerAnalysisDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharitableTrustDesignerAnalysisDataQuery, CharitableTrustDesignerAnalysisDataQueryVariables>(CharitableTrustDesignerAnalysisDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCharitableTrustDesignerAnalysisDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CharitableTrustDesignerAnalysisDataQuery, CharitableTrustDesignerAnalysisDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharitableTrustDesignerAnalysisDataQuery, CharitableTrustDesignerAnalysisDataQueryVariables>(CharitableTrustDesignerAnalysisDataDocument, withFetchPolicyContext(options));
        }
export type CharitableTrustDesignerAnalysisDataQueryHookResult = ReturnType<typeof useCharitableTrustDesignerAnalysisDataQuery>;
export type CharitableTrustDesignerAnalysisDataLazyQueryHookResult = ReturnType<typeof useCharitableTrustDesignerAnalysisDataLazyQuery>;
export type CharitableTrustDesignerAnalysisDataSuspenseQueryHookResult = ReturnType<typeof useCharitableTrustDesignerAnalysisDataSuspenseQuery>;
export type CharitableTrustDesignerAnalysisDataQueryResult = Apollo.QueryResult<CharitableTrustDesignerAnalysisDataQuery, CharitableTrustDesignerAnalysisDataQueryVariables>;